import Container from "@material-ui/core/Container"
import Link from "@material-ui/core/Link"
import Paper from "@material-ui/core/Paper"
import Typography from "@material-ui/core/Typography"
import moment from "moment"
import React, { forwardRef } from "react"
import styled from "styled-components"
import { createPhoneLink } from "../../helpers"
import { ActiviteitFieldsFragment } from "../../__generated__/graphql-gatsby"
import CollapseDates from "./CollapseDates"
import DataTable from "./dataTable"
import LocationLink from "./locationLink"

interface IProps {
  data: Maybe<ActiviteitFieldsFragment>
  title: Maybe<string>
}

interface ISpacer {
  spacing?: number
}

const DetailWrapper = styled(Paper)`
  margin-top: ${({ theme }) => theme.spacing(4)}px;
  margin-bottom: ${({ theme }) => theme.spacing(4)}px;
  padding: ${({ theme }) => theme.spacing(4)}px;
  background-color: ${({ theme }) => theme.palette.primary.light};
  color: ${({ theme }) => theme.palette.text.primary};

  @media (max-width: ${({ theme }) => theme.breakpoints.values.sm}px) {
    padding: ${({ theme }) => theme.spacing(2)}px;
  }
`
const Spacer = styled.div<ISpacer>`
  min-height: ${({ theme, spacing }) => theme.spacing(spacing ? spacing : 2)}px;
`

const DefaultLink = styled(Link)`
  color: ${({ theme }) => theme.palette.secondary.dark};
  font-weight: bold;
`

const AanvullendeData = styled.div`
  padding: ${({ theme }) => `0 ${theme.spacing(6)}px`};

  @media (max-width: ${({ theme }) => theme.breakpoints.values.md}px) {
    padding: ${({ theme }) => `0 ${theme.spacing(2)}px`};
  }
  @media (max-width: ${({ theme }) => theme.breakpoints.values.sm}px) {
    padding: 0;
  }
`

const EventDetails = forwardRef<HTMLDivElement, IProps>(
  ({ data, title }, ref) => {
    const recurring = data?.terugkerendeActiviteit
    const hideDate = Boolean(data?.verbergDatum)
    const hideTime = Boolean(data?.verbergTijd)
    const hideWhen = Boolean(data?.verbergWanneer)
    const showSignUp = data?.aanmeldenEmail || data?.aanmeldenTelefoon
    const dateFormat = "D MMMM YYYY"
    const dateLabel = data?.heeftAanvullendeData ? "Start datum" : "Wanneer"

    return (
      <Container maxWidth="md" ref={ref}>
        <DetailWrapper elevation={10}>
          <Typography variant="h3" component="p" align="center" gutterBottom>
            Details
          </Typography>
          <DataTable
            rows={[
              ...(!hideWhen
                ? [
                    {
                      label: `${dateLabel}: `,
                      data: recurring
                        ? data?.dates?.text
                        : moment(new Date(data?.datum || 0)).format(dateFormat),
                    },
                  ]
                : []),
              ...(recurring && !hideDate && data?.dates?.start_date
                ? [
                    {
                      label: "Start datum: ",
                      data: moment(data.dates.start_date).format(dateFormat),
                    },
                  ]
                : []),
              ...(recurring && !hideDate && data?.dates?.end_date
                ? [
                    {
                      label: "Eind datum: ",
                      data: moment(data.dates.end_date).format(dateFormat),
                    },
                  ]
                : []),
              ...(data?.startTijd && !hideTime
                ? [
                    {
                      label: "Start tijd: ",
                      data: data.startTijd,
                    },
                  ]
                : []),
              ...(data?.eindTijd && !hideTime
                ? [
                    {
                      label: "Eind tijd: ",
                      data: data.eindTijd,
                    },
                  ]
                : []),
            ]}
          />
          <Spacer />
          <DataTable
            rows={[
              ...(data?.begeleider
                ? [
                    {
                      label: "Begeleid door: ",
                      data: data.begeleider,
                    },
                  ]
                : []),
              ...(data?.kosten
                ? [
                    {
                      label: "Eigen bijdrage: ",
                      data: data.kosten,
                    },
                  ]
                : []),
            ]}
          />
          <Spacer />
          <LocationLink location={data?.locatie} />
          <Typography align="center" component="p">
            {showSignUp && (
              <>
                Aanmelden kan via:{" "}
                {data?.aanmeldenEmail && (
                  <DefaultLink
                    href={`mailto:${data.aanmeldenEmail}?SUBJECT=Aanmelding: ${title}`}
                  >
                    {data.aanmeldenEmail}
                  </DefaultLink>
                )}
                {data?.aanmeldenTelefoon && (
                  <>
                    {data?.aanmeldenEmail && <> of via </>}
                    <DefaultLink href={createPhoneLink(data.aanmeldenTelefoon)}>
                      {data.aanmeldenTelefoon}
                    </DefaultLink>
                  </>
                )}
              </>
            )}
          </Typography>
        </DetailWrapper>
        {data?.heeftAanvullendeData && (
          <AanvullendeData>
            <CollapseDates dates={data.aanvullendeData} />
          </AanvullendeData>
        )}
        <Spacer spacing={6} />
      </Container>
    )
  }
)

export default EventDetails
